import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

export interface Option {
  name: string;
  value?: string | number;
}

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html'
})
export class SelectFieldComponent {
  @Input() label!: string;
  @Input() options!: Option[];
  @Input() placeholder: string = '選択して下さい';
  @Input() cancel?: string;
  @Output() formChange = new EventEmitter<FormControl>();

  required: boolean = false;

  private _form!: FormControl;
  @Input()
  get form(): FormControl {
    return this._form;
  }
  set form(form: FormControl) {
    this._form = form;
    this.required = form.hasValidator(Validators.required);
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
